import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="main-footer" className="bg-[#2C5263] text-white/80 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="space-y-4">
            <h3 className="text-2xl font-serif text-white font-bold">
              Cavallino Treporti
            </h3>
            <p className="text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/appartamenti" data-testid="footer-link-apartments" className="hover:text-white transition-colors text-sm">{t('nav.apartments')}</Link></li>
              <li><Link to="/location" data-testid="footer-link-location" className="hover:text-white transition-colors text-sm">{t('nav.location')}</Link></li>
              <li><Link to="/galleria" data-testid="footer-link-gallery" className="hover:text-white transition-colors text-sm">{t('nav.gallery')}</Link></li>
              <li><Link to="/contatti" data-testid="footer-link-contact" className="hover:text-white transition-colors text-sm">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.contacts')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="mt-0.5 flex-shrink-0" />
                <span className="text-sm">Via del Marinaio<br />30013 Cavallino Treporti (VE)</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} className="flex-shrink-0" />
                <a href="tel:+393201122733" data-testid="footer-phone-link" className="text-sm hover:text-white transition-colors">+39 320 112 2733</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} className="flex-shrink-0" />
                <a href="mailto:marco@casanereide.it" data-testid="footer-email-link" className="text-sm hover:text-white transition-colors">marco@casanereide.it</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">{t('footer.follow')}</h4>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="hover:text-white transition-colors">
                <Facebook size={24} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="hover:text-white transition-colors">
                <Instagram size={24} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <p className="text-center text-sm">
            © {new Date().getFullYear()} Casa Vacanze Cavallino Treporti. {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
